const ITEMS = [
  { key: "lights_toggled", label: "Lights Toggled", accent: "text-indigo-300" },
  { key: "timer_changes", label: "Sleep Timer Changes", accent: "text-sky-300" },
  { key: "fade_changes", label: "Volume Fade Changes", accent: "text-amber-300" },
  { key: "fade_completions", label: "Fades Completed", accent: "text-emerald-300" },
  { key: "auto_dims", label: "Auto Lights-Off", accent: "text-rose-300" },
];

export const SleepFeatureUsageWidget = ({ data, loading }) => {
  const usage = data?.sleep_usage || {};
  const total = Object.values(usage).reduce((s, v) => s + v, 0);

  return (
    <div data-testid="sleep-feature-usage-widget" className="bg-slate-900/80 border border-slate-800 rounded-xl p-5 shadow-lg backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Sleep Feature Usage</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : total === 0 ? (
        <p className="text-sm text-slate-500">No sleep-control interactions recorded yet.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {ITEMS.map((item) => (
            <div key={item.key} className="bg-slate-950/50 border border-slate-800 rounded-lg p-3">
              <p className="text-[10px] uppercase tracking-wider text-slate-500 font-mono mb-1">{item.label}</p>
              <p className={`text-xl font-bold font-mono ${item.accent}`}>{usage[item.key] || 0}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
